import { render, staticRenderFns } from "./bankruptcy-card.vue?vue&type=template&id=03330198&scoped=true&"
import script from "./bankruptcy-card.vue?vue&type=script&lang=js&"
export * from "./bankruptcy-card.vue?vue&type=script&lang=js&"
import style0 from "./bankruptcy-card.vue?vue&type=style&index=0&id=03330198&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03330198",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VDivider,VHover,VIcon})
